import React from "react";
import { FaUserPlus, FaMobileAlt, FaGift } from "react-icons/fa";

function StepCard({ icon: Icon, title, text }) {
  return (
    <div className="flex flex-col items-center text-center p-6 rounded-3xl bg-[#F6F6F7] border border-black/5 shadow-[0_6px_20px_rgba(0,0,0,0.06)]">
      <div className="flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-b from-[#FFEAF5] to-[#FAD0E3] mb-4 shadow-md">
        <Icon className="text-xl text-[#E35EA7]" />
      </div>
      <h3 className="text-lg sm:text-xl font-semibold mb-2">{title}</h3>
      <p className="text-sm sm:text-base text-neutral-700 leading-relaxed">
        {text}
      </p>
    </div>
  );
}

export default function CommentCaMarchePartenaires() {
  return (
    <section
      id="comment"
      className="relative mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 py-12 sm:py-16"
    >
      <h2 className="text-3xl sm:text-4xl font-asap font-semibold text-center mb-10">
        Comment ça marche ?
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        <StepCard
          icon={FaUserPlus}
          title="1. Devenez partenaire"
          text="Rejoignez le réseau en quelques minutes et bénéficiez d’une mise en place simple et rapide."
        />
        <StepCard
          icon={FaMobileAlt}
          title="2. Publiez & fidélisez"
          text="Ajoutez vos offres, événements et cartes de fidélité sur l’app, directement depuis votre espace commerçant."
        />
        <StepCard
          icon={FaGift}
          title="3. Gagnez en visibilité"
          text="Mettez en lumière vos atouts pour fidéliser davantage les citoyens claixois."
        />
      </div>
    </section>
  );
}